// extracted by mini-css-extract-plugin
module.exports = {"AnimatedTextWrapper":"AnimatedText_AnimatedTextWrapper__ZnAhB","AnimatedText":"AnimatedText_AnimatedText__V47Py","Word":"AnimatedText_Word__BpPO9"};